<template>
  <div>
    <viewTable
      ref="viewTable"
      :limits="limits"
      :columns-property="columnsProperty"
      :filter="filter"
      module="basic"
      url="workerGroups"
      :table-select="false"
      @addOrEdit="addEditHandle"
      @delete="deleteHandle"
      @reset="resetHandle"
    >
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="班组编号">
            <el-input v-model.trim="filter.groupNo" placeholder="请输入班组编号" clearable />
          </el-form-item>
          <el-form-item label="班组名称">
            <el-input v-model.trim="filter.groupName" placeholder="请输入班组名称" clearable />
          </el-form-item>
          <el-form-item label="班组分类">
            <el-select v-model="filter.groupType" clearable placeholder="请选择班组类型">
              <el-option v-for="(item, index) in groupTypeList" :key="index" :label="item.name" :value="item.code" />
            </el-select>
          </el-form-item>
        </el-form>
      </template>
    </viewTable>
    <WorkerGroupEdit ref="workerGroupEdit" @save-success="loadData" :groupTypeList="groupTypeList"></WorkerGroupEdit>
  </div>
</template>

<script>
import viewTable from "@/components/ViewTable.vue";
import WorkerGroupEdit from "./WorkerGroupEdit";
export default {
  components: { viewTable, WorkerGroupEdit },
  data() {
    return {
      limits: {
        addAuth: this.$auth(696),
        editAuth: this.$auth(697),
        delAuth: this.$auth(698),
      },
      groupTypeList: [],
      filter: {},
      columnsProperty: [
        {
          tooltip: true,
          key: "groupNo",
          width: 100,
          align: "center",
        },
        {
          tooltip: true,
          key: "groupTypeName",
          width: 120,
          align: "center",
        },
        {
          key: "groupName",
          minWidth: 120,
          tooltip: true,
        },
        {
          key: "groupMemberName",
          minWidth: 150,
          tooltip: true,
        },
        {
          key: "groupWorkCenterName",
          minWidth: 150,
          tooltip: true,
        },
        {
          key: "note",
          minWidth: 100,
          tooltip: true,
        },
        {
          tooltip: true,
          key: "groupLeaderName",
          width: 100,
          align: "center",
        },
        {
          tooltip: true,
          key: "creatorName",
          width: 100,
          align: "center",
        },
        {
          tooltip: true,
          key: "createTime",
          width: 160,
          align: "center",
        },
        {
          key: "action",
          align: "center",
          width: 140,
          slot: "action",
          fixed: "right",
        },
      ],
    };
  },

  created() {
    this.getGroupTypeList();
  },

  methods: {
    // 获取班组分类
    getGroupTypeList() {
      this.$http.get("basic", "dictionaries/dictEnum/WorkerGroupType").then((resp) => {
        if (resp.success) {
          this.groupTypeList = resp.data;
        }
      });
    },

    // 新增、编辑
    addEditHandle(row) {
      this.$refs.workerGroupEdit.open(row);
    },

    // 加载数据
    loadData(pageNum) {
      this.$refs.viewTable.loadData(pageNum);
    },

    // 删除
    deleteHandle(row) {
      this.$http.delete("basic", "workerGroups", row.pkId).then((resp) => {
        if (resp.success) {
          this.loadData();
          this.$message.success("删除成功");
        }
      });
    },

    resetHandle(filter) {
      this.filter = filter;
    },
  },
};
</script>
